<template>
  <div class="work-plan">
    <div style="height: 625px;">
      <el-scrollbar class="work-plan-list">
        <div
          style="padding-right: 15px;"
        >
          <el-card v-for="(item,index) in dataObj" :key="index" style="margin-top: 10px">
            <div class="planInfo">
              <div>
                <el-button type="text" class="planBtn" @click="handleDel(item)">删除</el-button>
                <el-button type="text" class="planBtn" @click="handleEdit(item)">编辑</el-button>
              </div>
              <!-- 计划状态 1-进行中 2-已完成 3-已取消 -->
              <div :class="item.statusClass">{{item.planStatusDesc}}</div>
              <div
                :class="item.planStatus === 1 ? 'planContent' : 'planContent completedContent'"
              >{{item.plainContent}}</div>
              <el-form style="margin-top:36px;">
                <el-row class="contentInfo">
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="产品类型:" prop="businessLevel">
                      <span class="value" style="margin-right: 10px">{{item.productType}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="产品型号:" prop="businessLevel">
                      <span class="value" style="margin-right: 10px">{{item.productModel}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="用量:" prop="businessLevel">
                      <span class="value" style="margin-right: 10px">{{item.usage}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="单位:" prop="businessLevel">
                      <span class="value" style="margin-right: 10px">{{item.usageUnit}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="24">
                    <el-form-item label="备注:" prop="businessLevel">
                      <span class="value" style="margin-right: 10px">{{item.remark}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="质量问题:" prop="businessLevel">
                      <span class="value" style="margin-right: 10px">{{item.qualityFlag == 0 ? '否': '是'}}</span>
                    </el-form-item>
                  </el-col>
                  <template v-if="item.qualityFlag === 1">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="问题体现:" prop="businessLevel">
                        <span class="value" style="margin-right: 10px">{{item.problem}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="问题产品数量:" prop="businessLevel">
                        <span class="value" style="margin-right: 10px" v-if="item.problemProductCount">{{item.problemProductCount}}{{item.usageUnit}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="更换型号:" prop="businessLevel">
                        <span class="value" style="margin-right: 10px">{{item.changeProductModel}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="更换数量:" prop="businessLevel">
                        <span class="value" style="margin-right: 10px"  v-if="item.changeProductCount">{{item.changeProductCount}}{{item.usageUnit}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="更换成本:" prop="businessLevel">
                        <span class="value" style="margin-right: 10px" v-if="item.changeCost">{{item.changeCost}}元</span>
                      </el-form-item>
                    </el-col> 
                  </template>
                  
                </el-row>
              </el-form>
            </div>
          </el-card>
        </div>
        <p class="tip">{{dataObj.length > 0 ? "没有更多了" : "暂无数据"}}</p>
      </el-scrollbar>
    <!-- 添加售后产品 -->
    <SaleProductDialog ref="saleProductDialogRef" @success="refresh"></SaleProductDialog>
    </div>
  </div>
</template>

<script>
import {
  deleteAfterSaleProduct
} from "@/api/crm/order";
import SaleProductDialog from "./saleProductDialog"
import { mapState } from "vuex";

export default {
  name: "SaleProduct",
  props: {
    dataObj: {
      type: Array,
      default: []
    }
  },
  components: {
    SaleProductDialog
  },
  data() {
    return {
      noMore: false
    };
  },
  methods: {
    refresh(){
      this.$emit('success')
    },
    // 删除售后产品
    handleDel(item){
      let that = this
      this.$confirm('确认删除该条数据吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = that.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading'
        });
        deleteAfterSaleProduct({
          id: item.id
        }).then(response => {
            this.$emit('success')
            loading.close();
            that.msgSuccess("删除成功");
          }
        ).catch(error => {
          loading.close()
        });
      })
    },
    // 编辑售后产品
    handleEdit(item){
      this.$refs.saleProductDialogRef.open(item.id, JSON.parse(JSON.stringify(item)));
    }
  }
};
</script>

<style lang='scss'>
.el-scrollbar {
  height: 100%;
}

.work-plan {
  font-size: 14px;

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .item-info {
    margin-left: 25px;
    padding-right: 20px;

    .el-form-item {
      margin-bottom: 0;
    }

    .el-form-item__label {
      color: #8e8c8c;
    }

    .el-form-item__content {
      font-weight: 700;
    }

    .el-link--inner {
      margin-top: -3px;
    }
  }

  .card-title {
    margin: 0 0 15px 15px;
    border-left: 3px solid #4480f3;
    padding-left: 15px;
    font-size: 17px;
    font-weight: bold;
  }

  .status-btn {
    padding: 4px 7px;
    color: white;
    width: 56px;
    position: relative;
    top: 5px;
  }

  .statusCompleted {
    background-color: #04b95a;
  }

  .statusExecuting {
    background-color: #4480f3;
  }

  .statusCanceled {
    background-color: #b1b1b1;
  }

  .planContent {
    line-height: 1.5em;
    margin-left: 15px;
    font-weight: bold;
    position: relative;
    top: -18px;
    left: 55px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - 260px);
  }

  .completedContent {
    color: gray;
  }

  .contentInfo {
    margin-top: 10px;
    color: gray;
    font-weight: 500;
  }

  .redColor {
    color: red;
  }

  .plan-content {
    margin-bottom: 9px !important;
  }

  .planBtn {
    float: right;
    margin-right: 10px;
  }

  .tip {
    text-align: center;
    color: #909399;
    font-size: 14px;
  }

  .msg-box {
    position: relative;

    .msgInfo {
      width: 100%;
      height: 150px;
      border: 1px solid #aaa;
      border-radius: 6px;
      //padding: 5px 10px 20px;
      line-height: 2;
      white-space: pre-wrap;
      margin-bottom: 10px;
      overflow: auto;
    }

    .word-number {
      position: absolute;
      bottom: 2px;
      right: 20px;
      margin: 0;
      background: #fff;
    }

    .msgInfo:empty:before {
      content: "请输入需要完成的计划内容";
      font-size: 14px;
      color: #bebec3;
    }

    .msgInfo:focus:before {
      content: none;
    }
  }

  .atwho-view {
    top: 1.6em !important;
    left: 0 !important;
    bottom: unset !important;
  }
}
</style>
